module.exports = __webpack_public_path__ + "54cf98f5/img/document.e2130c6b.svg";